import { TRootState } from 'Redux/Reducers';

export const getBillingDetails = (state: TRootState) => state.payment.billingDetails;
